import { 
    getUserInfo, 
    getUserContent, 
    getCustomDeivceInfo, 
    getDeviceInfo, 
    getTabCount, 
    lightCheck,
} from "./action";
import { encryptionKey } from '../utils/api';
import { getCookie } from "@/utils/cookie";
import { osName } from '@/utils/device';

const isIOS = osName == 'ios'

// detail url
const LINK_LIST = {
    profile_detail:'kwaiying://krn?bundleId=profile&componentName=profile-detail',//个人资料
    template_manage:'kwaiying://krn?bundleId=profile&componentName=profile',//模板管理
    model_tab:'kwaiying://krn?bundleId=profile&componentName=profile&customTab=model&showBackIcon=true',//喜欢的模板
    course_tab:'kwaiying://krn?bundleId=profile&componentName=profile&customTab=like&showBackIcon=true',//喜欢的教程
    ks_friends:'kwaiying://krn?bundleId=KyFollowPage&componentName=friends',//快手好友
    ky_follow:`kwaiying://krn?bundleId=KyFollowPage&componentName=follow&from=ky_service&userId=${getCookie('userId')}&subtab=follow`,//快影关注
    ky_fans:`kwaiying://krn?bundleId=KyFollowPage&componentName=follow&from=ky_service&userId=${getCookie('userId')}&subtab=fans`,//快影粉丝
}

// page title
export const PAGE_TITLE = {
    base: '用户基本信息',
    account: '账号信息',
    works: '作品信息',
    location: '位置信息',
    social: '社交信息',
    device: '设备信息',
}

// 用户身份信息
export const getBaseData = async ()=>{
    const userData = await getUserInfo()
    const logInfo = await getUserContent()
    let isLoged = ''
    if(isIOS){
        isLoged = logInfo ? logInfo.profile[0]['昵称'] : ''
    }else{
        isLoged = logInfo ? logInfo.profile['昵称'] : ''
    }
    const listInfo = {
        totals: 2,
        data:[
            {
                infoName:'头像',
                useReason:'完善资料、社交互动',
                useScene:'用户填写提交个人资料时、个人主页/评论列表/直播间展示时',
                collectStatus: isLoged ? '1条' : '未收集' ,
                collectData: isLoged ? `linkType${LINK_LIST['profile_detail']}` : '无'
            },{
                infoName:'昵称',
                useReason:'完善资料、社交互动',
                useScene:'用户填写提交个人资料时、个人主页/评论列表/直播间展示时',
                collectStatus: isLoged ? '1条' : '未收集' ,
                collectData: (userData && isLoged) ? userData.data.data.nickName : '无'
            }
        ]
    }
    return listInfo
}

//账号信息
export const getAccountData = async () => {
    const { profile = {} }= await getUserContent()
    let formalInfo = {}
    if(isIOS){
        for(let i=0; i<profile.length; i++){
            for(let key in profile[i]){
                formalInfo[key] = profile[i][key]
            }
        }
    }else{
        formalInfo = profile
    }
    const isLoged = formalInfo['昵称'] || ''
    const phoneNum = formalInfo['手机号'] || '无'
    const thirdInfo = isLoged ?`${formalInfo['昵称']},${formalInfo['平台']}` : '无'
    
    const listInfo = {
        totals: 2,
        data:[
            {
                infoName:'手机号',
                useReason:'创建账号、登录账号',
                useScene:'用户注册/登录账号',
                collectStatus: phoneNum !=='无' ? '1条':'未收集',
                collectData: isIOS ? phoneNum : encryptionKey(phoneNum,'phone')
            },{
                infoName:'第三方登录账号',
                useReason:'三方登录',
                useScene:'利用三方账号创建快影账号时、进行账号绑定时',
                collectStatus: isLoged ? '1条':'未收集',
                collectData: thirdInfo,
            }
        ]
    }
    return listInfo
}
//作品信息
export const getWorksData =async () => {
    const worksData = await getTabCount()
    const isLightData = await lightCheck()
    let { isLightCreator=false } = isLightData.data||{}
    let worksNum = worksData ? `${worksData.data.templateCount}条` : '无'
    const listInfo = {
        totals: 1,
        data:[
            {
                infoName:'发布模板',
                useReason:'作品展示、信息审核',
                useScene:'主页展示时、作品推荐给其他用户时',
                collectStatus: worksNum,
                collectData:isLightCreator ? `linkType${LINK_LIST['template_manage']}`:'无'
            }
        ]
    }
    return listInfo
}
//位置信息
export const getLocationData = async () => {
    const accountInfo = await getUserContent()
    let { ipAddress = '无'} = accountInfo
    const listInfo = {
        totals: 1,
        data:[
            {
                infoName:'IP地址',
                useReason:'内容推荐、内容发布、安全风控',
                useScene:'使用基于位置信息提供的服务时',
                collectStatus: ipAddress == '无' ? '未收集' : '1条',
                collectData: encryptionKey(ipAddress,'ip')
            }
        ]
    }
    return listInfo
}
//社交信息
export const getSocialData = async () => {
    const socailData = await getTabCount();
    let { fansCount=0, followCount=0, ksFollowCount=0, likeCourseCount=0, likeTemplateCount=0 } = socailData.data || {}
    const listInfo = {
        totals: 5,
        data:[
            {
                infoName:'粉丝',
                useReason:'主页展示',
                useScene:'别人关注时、查看粉丝列表时',
                collectStatus:`${fansCount}条`,
                collectData: fansCount!==0?`linkType${LINK_LIST['ky_fans']}`:'无'
            },{
                infoName:'关注',
                useReason:'主页展示',
                useScene:'关注用户时、查看关注列表时',
                collectStatus:`${followCount}条`,
                collectData:followCount!==0?`linkType${LINK_LIST['ky_follow']}`:'无'
            },{
                infoName:'我的快手好友',
                useReason:'主页展示',
                useScene:'查看关注的快手用户在快影的账号，可进行关注',
                collectStatus:`${ksFollowCount}条`,
                collectData:ksFollowCount!==0?`linkType${LINK_LIST['ks_friends']}`:'无'
            },{
                infoName:'喜欢的模板',
                useReason:'主页展示、个性化服务',
                useScene:'主页展示收藏作品时、内容推荐时',
                collectStatus:`${likeTemplateCount}条`,
                collectData:likeTemplateCount!==0?`linkType${LINK_LIST['model_tab']}`:'无'
            },{
                infoName:'喜欢的教程',
                useReason:'主页展示、个性化服务',
                useScene:'主页展示收藏作品时、内容推荐时',
                collectStatus:`${likeCourseCount}条`,
                collectData:likeCourseCount!==0?`linkType${LINK_LIST['course_tab']}`:'无'
            }
        ]
    }
    return listInfo
}
//设备信息
export const getDeviceData = async () => {
    const deviceInfo = await getCustomDeivceInfo()
    const baseInfo = await getDeviceInfo()
    let { did='无', appVersion='无' } = baseInfo
    let { carrierName='无', deviceMode='无', screenRatio={} } = deviceInfo
    let ratio = ''
    if(isIOS){
        ratio = screenRatio ?`${screenRatio[1]['宽']}*${screenRatio[0]['高']}` : '无'
    }else{
        ratio = screenRatio ?`${screenRatio['宽']}*${screenRatio['高']}` : '无'
    }
    const listInfo = {
        totals: 5,
        data:[
            {
                infoName:'网络运营商',
                useReason:'登录账号',
                useScene:'使用登录功能时',
                collectStatus: carrierName == '无'?'未收集':'1条',
                collectData: carrierName
            },{
                infoName:'分辨率',
                useReason:'视频浏览',
                useScene:'提供优质的视频浏览功能时',
                collectStatus: ratio == '无'?'未收集':'1条',
                collectData: ratio
            },{
                infoName:'设备型号',
                useReason:'安全风控、兼容性判断、广告推送、统计数据及效果分析、消息推送',
                useScene:'判断安全风控事件时、个性化推荐时、兼容性判断时、推送通知时',
                collectStatus: deviceMode == '无'? '未收集' : '1条',
                collectData: deviceMode
            },{
                infoName:'APP版本',
                useReason:'安全风控、兼容性判断、广告推送、统计数据及效果分析、消息推送',
                useScene:'判断安全风控事件时、个性化推荐时、兼容性判断时、推送通知时',
                collectStatus: appVersion == '无'? '未收集' : '1条',
                collectData: appVersion
                
            },{
                infoName:'deviceId',
                useReason:'安全风控、广告推送',
                useScene:'判断安全风控事件时、个性化推荐时',
                collectStatus: did == '无'? '未收集' : '1条',
                collectData: encryptionKey(did,'did')
            },{
                infoName:'IMEI',
                useReason:'安全风控、广告推送',
                useScene:'判断安全风控事件时、个性化推荐时',
                collectStatus:'未收集',
                collectData:'无'
            },{
                infoName:'IMSI',
                useReason:'安全风控、广告推送',
                useScene:'判断安全风控事件时、个性化推荐时',
                collectStatus:'未收集',
                collectData:'无'
            },{
                infoName:'OAID',
                useReason:'安全风控、广告推送',
                useScene:'判断安全风控事件时、个性化推荐时',
                collectStatus:'未收集',
                collectData:'无'
            },{
                infoName:'IDFA(iOS)',
                useReason:'安全风控、广告推送',
                useScene:'判断安全风控事件时、个性化推荐时',
                collectStatus:'未收集',
                collectData:'无'
            }
        ]
    }
    return listInfo
}


